import React from "react";
import {
  Box,
  Typography,
  Button,
} from "@mui/material";
import { colors } from "../../constants/Colors";
import useIsMobile from "../../hooks/useIsMobile";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { CompanyType } from "../../types/generalTypes";

interface FinalStepProps {
  company: CompanyType;
  onCopyLink: () => void;
  onViewPage: () => void;
  onCompleteOnboarding: () => void;
}

const FinalStep = ({ company, onCopyLink, onViewPage, onCompleteOnboarding }: FinalStepProps) => {
  const isMobile = useIsMobile();
  const publicLink = `anotareservas.com/${company?.pathRouteKey}`;

  return (
    <Box>
      <Typography
        sx={{
          fontWeight: 500,
          marginBottom: isMobile ? "12px" : "16px",
          color: "#22303E",
          fontSize: isMobile ? "14px" : "16px",
        }}
      >
        Parabéns! Sua página de agendamento está pronta:
      </Typography>

      <Box
        sx={{
          backgroundColor: "#f5f5f5",
          padding: isMobile ? "12px" : "12px 16px",
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          marginBottom: isMobile ? "12px" : "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: isMobile ? "column" : "row",
          gap: isMobile ? "8px" : "0px",
        }}
      >
        <Typography
          sx={{
            fontFamily: "monospace",
            fontWeight: 600,
            color: colors.blue,
            fontSize: isMobile ? "14px" : "16px",
            wordBreak: "break-all",
          }}
        >
          {publicLink}
        </Typography>
        <Button
          onClick={onCopyLink}
          startIcon={<ContentCopyIcon />}
          size={isMobile ? "small" : "medium"}
          sx={{
            color: colors.blue,
            textTransform: "none",
            fontWeight: 550,
            fontSize: isMobile ? "14px" : "16px",
          }}
        >
          Copiar Link
        </Button>
      </Box>

      <Box sx={{ 
        display: "flex", 
        gap: isMobile ? "8px" : "12px", 
        flexDirection: "column"
      }}>
        <Button
          variant="outlined"
          onClick={onViewPage}
          fullWidth
          sx={{
            borderColor: colors.blue,
            color: colors.blue,
            "&:hover": {
              borderColor: colors.darkBlue,
              backgroundColor: "rgba(34, 111, 226, 0.04)",
            },
            fontWeight: 550,
            padding: isMobile ? "14px" : "12px",
            fontSize: isMobile ? "16px" : "14px",
          }}
        >
          Ver minha página
        </Button>
        <Button
          variant="contained"
          onClick={onCompleteOnboarding}
          fullWidth
          sx={{
            backgroundColor: colors.blue,
            "&:hover": {
              backgroundColor: colors.darkBlue,
            },
            fontWeight: 550,
            padding: isMobile ? "14px" : "12px",
            fontSize: isMobile ? "16px" : "14px",
          }}
        >
          Ir para o Dashboard
        </Button>
      </Box>
    </Box>
  );
};

export default FinalStep; 